import React from "react";

/**
 * Official WhatsApp icon (SVG) — crisp, transparent, color customizable.
 * Default uses the official WhatsApp green (#25D366).
 */
export default function WhatsAppIcon({ size = 24, color = "#25D366", className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill={color}
      className={className}
      aria-hidden="true"
    >
      <path d="M16.001 0C7.165 0 0 7.163 0 16c0 2.827.737 5.59 2.137 8.022L0 32l8.157-2.142A15.93 15.93 0 0 0 16 32c8.836 0 16-7.163 16-16S24.836 0 16.001 0zm0 29.236a13.21 13.21 0 0 1-6.728-1.85l-.483-.286-4.84 1.27 1.293-4.715-.314-.499A13.176 13.176 0 0 1 2.79 16C2.79 8.704 8.705 2.79 16 2.79 23.296 2.79 29.21 8.704 29.21 16c0 7.296-5.914 13.236-13.21 13.236zm7.262-9.91c-.398-.198-2.355-1.161-2.72-1.294-.366-.134-.633-.198-.9.198-.265.398-1.03 1.295-1.262 1.56-.232.265-.464.298-.862.099-.398-.198-1.682-.62-3.205-1.977-1.184-1.057-1.984-2.362-2.215-2.76-.232-.398-.025-.613.175-.81.18-.18.398-.464.598-.696.198-.232.265-.398.398-.663.134-.265.067-.498-.034-.697-.099-.198-.9-2.166-1.232-2.966-.324-.778-.654-.673-.9-.685l-.766-.014c-.265 0-.696.099-1.06.498-.366.398-1.392 1.36-1.392 3.317s1.426 3.847 1.625 4.112c.198.265 2.808 4.29 6.806 6.018.951.41 1.692.654 2.27.838.953.302 1.821.26 2.508.158.765-.115 2.355-.963 2.689-1.894.331-.93.331-1.728.232-1.894-.099-.166-.365-.265-.764-.464z" />
    </svg>
  );
}
